module Shared.Dto.User

open System

type Package = {
    Name: string
    Code: string
    Price: Decimal
}

type PurchasedPackage = {
    PackageId: int
    PurchasedAt: DateTimeOffset
    ValidUntil: DateOnly
    CanceledAt: DateTimeOffset option
}

type Role =
    | Admin
    | RegularUser
    | TestUser

type UserDto = {
    Id: int
    FirstName: string
    LastName: string
    Role: Role
}

let getFullName (user: UserDto) : string =
    sprintf "%s %s" user.FirstName user.LastName

let getFullNameLastFirst (user: UserDto) : string =
    sprintf "%s %s" user.LastName user.FirstName

type LoggedInUserDto = {
    Id: int
    FirstName: string
    LastName: string
    Role: Role
    FeatureFlags: string list
    OriginalUser: LoggedInUserDto option
}

let loggedInUserFullName (user: LoggedInUserDto) : string =
    sprintf "%s %s" user.FirstName user.LastName